var _style, _circle, _circle2, _circle3, _circle4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStressNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#60B714;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#60B714;}\r\n\t.st3{fill:#60B714;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 100.6,
    cy: 100,
    r: 90.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 100.4,
    cy: 101,
    r: 79.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 63.4,
    cy: 77.5,
    r: 11.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 137.4,
    cy: 77.8,
    r: 11.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.5,126.1c0,0,11.6,20.4,36.7,13.5c3.8-1.3,10.3-3.3,17.3-13.5c1.3-1.5,3.1-4.4,6.9-1.3 c0.7,0.9,2.5,2.9-0.5,6.4c-1.7,2.6-12,18.8-35.3,18.1c-2.5-0.2-20.5-1.1-32-18.8c-0.5-1-1.7-4,0.6-6 C68.6,124.2,70.6,121.2,74.5,126.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressNormal);
export default __webpack_public_path__ + "static/media/StressNormal.9741f9685e6bd13037aeeb45ebf1e420.svg";
export { ForwardRef as ReactComponent };